import { render, staticRenderFns } from "./NewLargeBookForm.vue?vue&type=template&id=3b0f2e50&"
import script from "./NewLargeBookForm.vue?vue&type=script&lang=js&"
export * from "./NewLargeBookForm.vue?vue&type=script&lang=js&"
import style0 from "./NewLargeBookForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports